import PubSub from 'pubsub-js';

const ToastService = {
	show: function(text, type) {
		PubSub.publish('toast',{text: text, type: type});
	}
}

export default ToastService;